import { Waiter } from "common/promises/waiter";
export class Canceler {
    constructor() {
        this.canceled = false;
        this.waiter = new Waiter();
    }
    cancel() {
        this.canceled = true;
        this.waiter.trigger();
    }
    wait() {
        return this.waiter.wait();
    }
    /**
     * Cancel 해야하는 시점이면 CancelError를 throw한다.
     * cancel.root로 시작한 promise였다면 CancelError를 무시하고
     * Promise를 리턴한다.
     */
    check() {
        if (this.canceled) {
            throw new CancelError();
        }
    }
}
/**
 * Cancel이 가능한 promise를 만든다.
 *
 * 예시
 * ```typescipt
 * function loop(canceler) {
 *   while (true) {
 *     canceler.check();
 *     console.log("loop");
 *   }
 * }
 *
 * const {promise, canceler} = canel.root(loop);
 * canceler.cancel();
 * await promise;
 * ```
 */
export function root(promiseMaker) {
    const canceler = new Canceler();
    const runPromise = async () => {
        try {
            return await c(promiseMaker, canceler);
        }
        catch (err) {
            if (err instanceof CancelError) {
                return null;
            }
            throw err;
        }
    };
    return {
        promise: runPromise(),
        canceler,
    };
}
/**
 * cancel된 상황이면 promise를 실행하지 않는다.
 */
export async function c(promiseMaker, canceler) {
    if (canceler.canceled) {
        throw new CancelError();
    }
    else {
        return await promiseMaker(canceler);
    }
}
export class CancelError extends Error {
    constructor(...params) {
        super(...params);
        // Maintains proper stack trace for where our error was thrown (only available on V8)
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, CancelError);
        }
        // Custom debugging information
        this.date = new Date();
    }
}
//# sourceMappingURL=canceler.js.map